import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Pencil = createSvgIcon(
  () => (
    <path d="M24.1975 7.54844C25.0882 6.65775 25.0882 5.20452 24.1975 4.36072L21.3848 1.54802C20.541 0.657333 19.0877 0.657333 18.1971 1.54802L16.0407 3.70442C15.8531 3.89193 15.8531 4.26696 16.0407 4.50135L21.2441 9.70484C21.4785 9.89235 21.8536 9.89235 22.0411 9.70484L24.1975 7.54844ZM14.2124 5.53267L1.88342 17.8617L0.898974 23.5339C0.758339 24.3309 1.41463 24.9872 2.21156 24.8465L7.88383 23.8621L20.2128 11.5331C20.4472 11.3456 20.4472 10.9705 20.2128 10.7362L15.0093 5.53267C14.7749 5.34516 14.3999 5.34516 14.2124 5.53267ZM5.02426 20.7212H7.27442V22.4557L4.22733 22.9714L2.7741 21.5182L3.28976 18.4711H5.02426V20.7212Z" />
  ),
  '0 0 25 25'
);
